<ng-container [ngSwitch]="menuItem?.menuType">
  <shrd-pf-ft-contact-footer
    (closeAction)="closeContentCard()"
    *ngSwitchCase="menuTypes.CONTACT"
    [userData]="userData"
  ></shrd-pf-ft-contact-footer>
  <shrd-uic-smartbar *ngSwitchDefault [isFixed]="false" [isLight]="true">
    <div class="smartbar-column-left">
      <div class="content-box">
        <button (click)="closeContentCard()" shrdUicButton variant="tertiaryMinorBorderless">
          <shrd-uic-svg-icon icon="arrow-left"></shrd-uic-svg-icon>
        </button>
      </div>
    </div>
  </shrd-uic-smartbar>
</ng-container>
